<template>
  <v-container
    grid-list-md
    justify-start
    fluid
    class="pl-0 pr-6 mb-4"
  >
    <v-layout
      row
      wrap
    >
      <v-row>
        <project-grid-item
          v-for="(project, index) in histProjects"
          :key="index"
          :project-data="project"
          @refresh="refresh()"
          @click.native="defineCurrent(project)"
        >
          {{ project.name }}
        </project-grid-item>
        <v-flex
          xs12
          sm6
          md4
          lg2
          xl2
        >
          <dialog-open-project
            :text="$t('dialog.more')"
            width="100%"
            height="100%"
          />
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
// Components
import projectGridItem from "./ProjectGridItem";
import dialogOpenProject from "../Dialog/DialogOpenProject";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector";
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector";

// Tools
const pathInfo = require("path");
const ft = require("@/components/Tools/FileTools");

export default {
  components: {
    dialogOpenProject,
    projectGridItem,
  },
  props: {
    current: {
      type: Object,
      default: function () {
        return {
          name: "none",
          width: 0,
          height: 0,
          type: "none",
        };
      },
    },
  },
  data() {
    return {
      profileFavouriteConnector: new ProfileFavouriteConnector(this.$store.state.user),
      projectConnector: new ProjectConnector(this.$store.state.user),
      histProjects: [],
      width: 200,
      height: 200,
    };
  },
  computed: {
    heightComponent() {
      return "width: " + window.innerWidth + "px; height: " + window.innerHeight / 3 + "px; overflow: auto;";
    },
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.refresh();
    }
  },
  methods: {
    // TODO: Triple declaration of checkExistProject method
    checkExistProject(element) {
      return new Promise(async (resolve, reject) => {
        const exist = await ft.exists("./" + element.path).catch((err) => {
          console.error(err);
          return reject(err);
        });

        if (exist) {
          return resolve(this.createObject(element));
        } else {
          // Add flag notfound on project
          let path = element.path;

          if (path.indexOf("./") == 0) {
            path = path.slice(2, path.length);
          }

          // TODO: Why not using project id instead of path ?
          this.projectConnector.addFlagNotfound(path);
          return reject("Project not found");
        }
      });
    },
    createObject(element) {
      let id_proj = element.id_proj;

      if (id_proj === undefined) {
        id_proj = element.proj_id;
      }

      // GET BASENAME WITHOUT EXTENSION
      const filename = pathInfo.basename(element.path, ".zip");

      // GET DIR IN MEDIACENTER + SOCID
      let dir = pathInfo.dirname(element.path);
      dir = dir.replace("mediacenter/" + this.$store.state.user.socId, "");
      dir = dir + "/";

      const project = {
        id: id_proj,
        name: filename,
        path: element.path,
        nameDir: dir,
        width: element.width,
        height: element.height,
        type: "project",
      };

      return project;
    },
    defineCurrent(project) {
      this.$emit("project-selected", project);
    },
    getHistProjects() {
      const promises = [];
      this.profileFavouriteConnector
        .getHistProjects(11)
        .then((projects) => {
          for (const project of projects) {
            promises.push(
              this.checkExistProject(project).catch((err) => {
                console.warn(err);
                return null;
              })
            );
          }

          Promise.all(promises)
            .then((result) => {
              // Filter results to remove null values
              this.histProjects = result.filter((element) => {
                if (element) return element;
              });
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refresh() {
      this.getHistProjects();
    },
  },
};
</script>

<style></style>
